/**
 * Class applied to the container that powerbi-client renders its report iframe into.
 * Also hard-coded in App.css, which cannot import this — change both together.
 */
export const POWER_BI_EMBED_CLASS = 'power-bi-embedded-report';

/** Attribute marking an iframe we embed ourselves (not via powerbi-client). */
export const EMBEDDED_CONTENT_ATTRIBUTE = 'data-embedded-content';

/** Spread onto an embedded iframe so clicks inside it are treated as clicks outside the nav. */
export const EMBEDDED_CONTENT_PROPS = { [EMBEDDED_CONTENT_ATTRIBUTE]: true } as const;

/**
 * Matches iframes whose internal clicks the parent document cannot observe — embedded reports and
 * videos the user can click on.
 *
 * Deliberately an allowlist: utility iframes such as Firebase's hidden auth helper must never count
 * as a user click. Mark any new embed rather than widening this to all iframes.
 */
export const EMBEDDED_CONTENT_IFRAME_SELECTOR = `.${POWER_BI_EMBED_CLASS} iframe, iframe[${EMBEDDED_CONTENT_ATTRIBUTE}]`;
